/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Route, Switch } from 'react-router';
// import logo from './assets/images/logo.svg'
import './App.scss';
import './assets/stylesheets/styles.scss';
import Moment from 'react-moment';
import 'moment-timezone';

// eslint-disable-next-line import/imports-first
import { connect } from 'react-redux';
import * as Actions from './actions/App';
import * as RT from './constants/Routing';
import Auth from './pages/Auth/Auth';

import SignUpPage from './pages/Auth/SignUp';
import LoginPage from './pages/Auth/Login';
import PasswordRegistrationPage from './pages/Auth/PasswordRegistration';
import PasswordResetPage from './pages/Auth/PasswordReset';
import PasswordReConfirmPage from './pages/Auth/PasswordReConfirm';
import TopPage from './pages/AfterLogin/Top';
import TaskNewPage from './pages/AfterLogin/Tasks/New';
import TaskIndexPage from './pages/AfterLogin/Tasks/Index';
import TaskOldIndexPage from './pages/AfterLogin/Tasks/OldIndex';
import TaskShowPage from './pages/AfterLogin/Tasks/Show';
import TaskEditPage from './pages/AfterLogin/Tasks/Edit';
import SettingIndexPage from './pages/AfterLogin/Setting/Index';
import SettingEditPage from './pages/AfterLogin/Setting/Edit';
import ContactPage from './pages/AfterLogin/Contacts';
import PaymentPage from './pages/AfterLogin/Invoice/Payment';
import InvoicePage from './pages/AfterLogin/Invoice/Invoice';
import RootPage from './pages/Root';
import InvoicePdf from './pages/AfterLogin/Invoice/InvoicePdf';
import ResumeParticipant from './pages/AfterLogin/Tasks/ResumeParticipant';
import ContractPDF from './pages/AfterLogin/Tasks/ContractPDF';
import FAQPage from './pages/AfterLogin/Faq/Faq';
import Template from './pages/AfterLogin/Template/Index';
import TemplateNew from './pages/AfterLogin/Template/New';
import TemplateEdit from './pages/AfterLogin/Template/Edit';

class Component extends React.Component {
  componentDidMount = () => {
    // console.log('すたて', this.props, this.state)
    Moment.globalTimezone = 'Asia/Tokyo';
    Moment.globalFormat = 'YYYY/MM/DD';
  };

  render() {
    return (
      <Switch>
        <Route exact path={RT.ROOT_PATH} component={RootPage} />
        <Route exact path={RT.SIGN_UP_PATH} component={SignUpPage} />
        <Route exact path={RT.SIGN_IN_PATH} component={LoginPage} />
        <Route exact path={RT.PASSWORD_REGISTRATION_PATH} component={PasswordRegistrationPage} />
        <Route exact path={RT.PASSWORD_RESET_PATH} component={PasswordResetPage} />
        <Route exact path={RT.PASSWORD_RE_CONFIRM_PATH} component={PasswordReConfirmPage} />

        <Auth>
          <Route exact path={RT.TOP_PATH} component={TopPage} />
          <Route exact path={RT.TASK_NEW_PATH} component={TaskNewPage} />
          <Route exact path={RT.TASK_DUPLICATE_PATH} component={TaskNewPage} />
          <Route exact path={RT.TASK_INDEX_PATH} component={TaskIndexPage} />
          <Route exact path={RT.TASK_OLD_INDEX_PATH} component={TaskOldIndexPage} />
          <Route exact path={RT.TASK_SHOW_PATH} component={TaskShowPage} />
          <Route exact path={RT.TASK_EDIT_PATH} component={TaskEditPage} />
          {/* <Route exact path={RT.SETTING_INDEX_PATH} component={SettingIndexPage} /> */}
          <Route exact path={RT.SETTING_EDIT_PATH} component={SettingEditPage} />
          <Route exact path={RT.CONTACT_PATH} component={ContactPage} />
          <Route exact path={RT.PAYMENT_PATH} component={InvoicePage} />
          <Route exact path={RT.PAYMENT_SHOW_PATH} component={PaymentPage} />
          <Route exact path={RT.RESUME_PARTICIPANT_PATH} component={ResumeParticipant} />
          <Route exact path={RT.CONTRACT_PDF_PATH} component={ContractPDF} />
          <Route exact path={RT.FAQ_PATH} component={FAQPage} />
          <Route exact path={RT.PAYMENT_PDF_PATH} component={InvoicePdf} />
          <Route exact path={RT.TEMPLATE_PATH} component={Template} />
          <Route exact path={RT.TEMPLATE_CREATE_PATH} component={TemplateNew} />
          <Route exact path={RT.TEMPLATE_EDIT_PATH} component={TemplateEdit} />
        </Auth>
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return state;
};
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const App = connect(mapStateToProps, mapDispatchToProps)(Component);

export default App;
